import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BadInputError, Entity, Guard, NotFoundError, Result, UniqueEntityID } from '@digibricks/domains';
export var SectionStatus;

(function (SectionStatus) {
  SectionStatus["New"] = "New";
  SectionStatus["Activate"] = "Activate";
})(SectionStatus || (SectionStatus = {}));

export var PreviousSectionId;

(function (PreviousSectionId) {
  PreviousSectionId["None"] = "none";
})(PreviousSectionId || (PreviousSectionId = {}));

export var Section = /*#__PURE__*/function (_Entity) {
  _inherits(Section, _Entity);

  var _super = _createSuper(Section);

  function Section() {
    _classCallCheck(this, Section);

    return _super.apply(this, arguments);
  }

  _createClass(Section, [{
    key: "formId",
    get: function get() {
      return this.props.formId;
    }
  }, {
    key: "title",
    get: function get() {
      return this.props.title;
    }
  }, {
    key: "description",
    get: function get() {
      return this.props.description;
    }
  }, {
    key: "parentSectionId",
    get: function get() {
      return this.props.parentSectionId;
    }
  }, {
    key: "previousSectionId",
    get: function get() {
      return this.props.previousSectionId;
    }
  }, {
    key: "status",
    get: function get() {
      return this.props.status;
    }
  }, {
    key: "files",
    get: function get() {
      return this.props.files;
    }
  }, {
    key: "audioFile",
    get: function get() {
      return this.props.audioFile;
    }
  }, {
    key: "titleIndex",
    get: function get() {
      return this.props.titleIndex;
    }
  }, {
    key: "aiChangeType",
    get: function get() {
      return this.props.aiChangeType;
    }
  }, {
    key: "clone",
    value: function clone() {
      var clonedSection = {
        id: this.props.id.toString(),
        title: this.props.title,
        description: this.props.description,
        previousSectionId: this.props.previousSectionId,
        status: this.props.status,
        files: this.props.files,
        audioFile: this.props.audioFile,
        formId: this.props.formId
      };
      return Section.create(clonedSection).getValue();
    }
  }, {
    key: "updateTitle",
    value: function updateTitle(title) {
      this.props.title = title;
      return Result.ok();
    }
  }, {
    key: "updateDescription",
    value: function updateDescription(description) {
      this.props.description = description;
      return Result.ok();
    }
  }, {
    key: "updatePreviousSectionId",
    value: function updatePreviousSectionId(previousSectionId) {
      this.props.previousSectionId = previousSectionId;
      return Result.ok();
    }
  }, {
    key: "updateFiles",
    value: function updateFiles(files) {
      this.props.files = files;
    }
  }, {
    key: "addFile",
    value: function addFile(file) {
      if (!file) {
        return new BadInputError('File cannot be null when adding new file');
      }

      this.props.files.push(file);
      return Result.ok();
    }
  }, {
    key: "deleteFile",
    value: function deleteFile(id) {
      var foundFile = this.props.files.find(function (f) {
        return f.id.toString() === id;
      });

      if (!foundFile) {
        return new NotFoundError('File does not existed');
      }

      this.props.files = this.props.files.filter(function (f) {
        return f.id.toString() !== id;
      });
      return Result.ok();
    }
  }, {
    key: "addAudioFile",
    value: function addAudioFile(audioFile) {
      if (!audioFile) {
        return new BadInputError('Audio file cannot be null when adding new audio file');
      }

      this.props.audioFile = audioFile;
      return Result.ok();
    }
  }, {
    key: "deleteAudioFile",
    value: function deleteAudioFile() {
      this.props.audioFile = null; // null indicates that the audio file is deleted

      return Result.ok();
    }
  }, {
    key: "updateAudioFile",
    value: function updateAudioFile(audioFile) {
      this.props.audioFile = audioFile;
      return Result.ok();
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      var _this$props$audioFile;

      return _objectSpread(_objectSpread({}, this.props), {}, {
        files: this.props.files.map(function (file) {
          return file.toJsonObject();
        }),
        audioFile: (_this$props$audioFile = this.props.audioFile) === null || _this$props$audioFile === void 0 ? void 0 : _this$props$audioFile.toJsonObject()
      });
    }
  }, {
    key: "updateStatus",
    value: function updateStatus(status) {
      this.props.status = status;
      return Result.ok();
    }
  }], [{
    key: "create",
    value: function create(props) {
      var _props$previousSectio, _props$files;

      var guardCollections = [{
        argument: props.id,
        argumentName: 'Section Id'
      }, {
        argument: props.title,
        argumentName: 'Section Title'
      }, {
        argument: props.description,
        argumentName: 'Description'
      }, {
        argument: props.previousSectionId,
        argumentName: 'Previous Section Id'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      var defaultProps = _objectSpread(_objectSpread({}, props), {}, {
        previousSectionId: (_props$previousSectio = props.previousSectionId) !== null && _props$previousSectio !== void 0 ? _props$previousSectio : PreviousSectionId.None,
        files: (_props$files = props.files) !== null && _props$files !== void 0 ? _props$files : []
      });

      return Result.ok(new Section(defaultProps, new UniqueEntityID(props.id)));
    }
  }, {
    key: "cloneTo",
    value: function cloneTo(props) {
      var clonedSection = Section.create({
        id: props.id.toString(),
        title: props.title,
        description: props.description,
        previousSectionId: props.previousSectionId,
        status: props.status,
        files: props.files,
        audioFile: props.audioFile,
        formId: props.formId
      });
      return clonedSection.getValue();
    }
  }]);

  return Section;
}(Entity);